import { render, staticRenderFns } from "./PhotoPreview.vue?vue&type=template&id=828902e8"
import script from "./PhotoPreview.vue?vue&type=script&lang=js"
export * from "./PhotoPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports